import { Box, Button, forwardRef, HStack, Text } from "@chakra-ui/react";
import { Trans } from "@lingui/macro";
import { CapacityAllocationTypeEnum } from "@src/__generated__/urql-graphql";
import { useResourcePlanningDailyViewStore } from "@src/components/modules/resource-planning/timeline/ResourcePlanningDayPage";
import { WrapComponent } from "@src/utils/components/WrapComponent";
import type { AllocationItemProps } from "@src/widgets/AllocationItem/AllocationItem";
import {
  AllocationPopover,
  type AllocationPopoverRef,
} from "@src/widgets/AllocationPopover/AllocationPopover";
import { observer } from "mobx-react-lite";
import { useRef } from "react";

export const HomeOfficeItem = observer(
  forwardRef<AllocationItemProps, "div">(({ userItem }, ref) => {
    const resourcePlanningStore = useResourcePlanningDailyViewStore();
    const popoverRef = useRef<AllocationPopoverRef>(null);
    const { from_time, to_time, type } = userItem;

    return (
      <WrapComponent
        // Wrap item in popover only if not dragging for better performance
        if={!resourcePlanningStore.active}
        with={(children) => (
          <AllocationPopover userItem={userItem} ref={popoverRef}>
            {children}
          </AllocationPopover>
        )}
      >
        <Button
          ref={ref}
          pos="relative"
          overflow="hidden"
          w="full"
          h="10"
          p="1"
          pl="3"
          bg="transparent"
          border="1px"
          borderColor="grey.300"
          onClick={() => {
            popoverRef.current?.onToggle();
          }}
          role="group"
          rounded="md"
          variant="unstyled"
        >
          <HStack justify="end">
            <Box flex="1">
              <Text
                w="full"
                fontSize="2xs"
                fontWeight="semibold"
                textAlign="left"
              >
                {type === CapacityAllocationTypeEnum.WeekendWork ? (
                  <Trans>Weekend Work</Trans>
                ) : (
                  <Trans>Home Office</Trans>
                )}
              </Text>
            </Box>
            <HStack pos="relative" zIndex="1">
              <HStack h="5" px="1" bg="grey.100" rounded="base">
                <Text fontSize="2xs" fontWeight="semibold">
                  {from_time}&nbsp;-&nbsp;{to_time}
                </Text>
              </HStack>
            </HStack>
          </HStack>
        </Button>
      </WrapComponent>
    );
  }),
);
